import { CreateMitarbeiterMutation } from '@/gql/graphql';

// oxlint-disable-next-line complexity
export function getWarningSearchParams(
  result:
    CreateMitarbeiterMutation['mitarbeiter_mitarbeiterCreate'] | undefined,
): string {
  if (!result) return '';
  const params = new URLSearchParams();

  if (result.success?.fristenResult?.result?.some((r) => !!r.failure)) {
    params.set('FristenWarning', 'true');
  }
  if (result.success?.personalzugang?.error) {
    params.set('PersonalzugangWarning', 'true');
  }
  if (result.personalfragebogenAntragError) {
    params.set('PersonalfragebogenWarning', 'true');
  }
  return params.toString();
}
